export const HOME = { emergentLink: 'emergent-link' }

export const NAV = {
  root: 'navigation',
  logo: 'nav-logo',
  commandBtn: 'nav-command-btn',
}

export const HERO = {
  section: 'hero-section',
  heading: 'hero-heading',
  viewWorkBtn: 'hero-view-work-btn',
  contactBtn: 'hero-contact-btn',
  resumeBtn: 'hero-resume-btn',
}

export const TIMELINE = { section: 'career-timeline' }
export const WORK = { section: 'case-studies' }
export const SKILLS = { section: 'skills-section' }

export const CONTACT = {
  section: 'contact-section',
  nameInput: 'contact-name-input',
  emailInput: 'contact-email-input',
  messageInput: 'contact-message-input',
  submitBtn: 'contact-submit-btn',
  successMsg: 'contact-success-msg',
  errorMsg: 'contact-error-msg',
}

export const COMMAND = {
  root: 'command-palette',
  input: 'command-palette-input',
  closeBtn: 'command-palette-close',
}
